import { Modal } from "antd";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import {
  MdAdd,
  MdAttachFile,
  MdClose,
  MdHelpOutline,
  MdOutlineDelete,
  MdOutlineFileDownload,
} from "react-icons/md";
import { bytesToMB } from "utils/helpers/files";
import Button from "../../Components/Button";
import Header from "../../Components/Header";
import Input from "../../Components/Input";

const DocumentUpload = ({
  items,
  label,
  onDownload,
  onUpload,
  onFileRemove,
  error,
  info,
}) => {
  const [infoVisible, setInfoVisible] = useState(false);
  return !isEmpty(items) ? (
    <div className="mobilityMutual__documents">
      <MdAttachFile className="mobilityMutual__documents--icon" size={24} />
      {items.map((item) => [
        <div className="mobilityMutual__documents--content">
          <div className="mobilityMutual__documents--content--name">
            {item?.name || ""}
          </div>
          <div className="mobilityMutual__documents--content--size">{`${
            get(item, "name", "").split(".")[1]
          } ${item?.size ? `| ${bytesToMB(item?.size)} Mo` : ""}`}</div>
        </div>,
        <div className="mobilityMutual__documents--actions">
          <div className="--download --action" onClick={() => onDownload(item)}>
            <MdOutlineFileDownload size={20} />
            <span>Télécharger</span>
          </div>
          <div className="--delete --action" onClick={() => onFileRemove(item)}>
            <MdOutlineDelete size={20} />
          </div>
        </div>,
      ])}
    </div>
  ) : (
    <>
      <div className="mobilityMutual__documents--uploader">
        <div className="--content">
          <MdAttachFile className="--icon" size={24} />
          <div className="--name">{label}</div>
          {info && (
            <div
              className="--info"
              onClick={() => setInfoVisible(!infoVisible)}
            >
              <MdHelpOutline size={20} />
            </div>
          )}
        </div>
        <Input
          type="file"
          showUploadList={false}
          fileList={items}
          onUpload={onUpload}
        >
          <Button type="primary-light" size="small">
            <MdAdd size={20} />
            <span>Ajouter</span>
          </Button>
        </Input>
      </div>
      {error && (
        <span className="mobilityMutual__documents--error">{error}</span>
      )}
      <Modal
        centered
        open={infoVisible}
        onCancel={() => setInfoVisible(false)}
        width={500}
        footer={null}
      >
        <div className="mutualMobility-help__modal">
          <Header small subtitle={"Á savoir"} title="" content={info} />
          <Button
            width={"100%"}
            type={"primary-outlined"}
            onClick={() => setInfoVisible(false)}
            className="mt-24"
          >
            <MdClose /> Fermer
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default DocumentUpload;
